@use '@/sass/variables';

.header {
  padding: variables.$spacing-medium;
  border-bottom: 1px solid variables.$gray;
  font-size: variables.$font-size-6;
  font-weight: 700;
  color: variables.$dark-gray;
}

.viewList {
  max-height: 300px;
  overflow-y: auto;
  padding: variables.$spacing-small;
}

.viewItem {
  display: flex;
  align-items: center;
  gap: variables.$spacing-small;
  padding: 0 variables.$spacing-small;
  background: none;
  border: none;
  border-radius: 4px;
  text-align: left;
  font-size: variables.$font-size-6;
  color: variables.$near-black;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: variables.$light-gray;
  }

  &.active {
    color: variables.$blue;
    font-weight: 500;
    background-color: variables.$lightest-blue;
  }
}

.viewSelect {
  flex: 1;
  min-width: 0;
  padding: variables.$spacing-small 0;
  cursor: pointer;
}

.viewName {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  font-size: variables.$font-size-5;
}

.viewActions {
  display: flex;
  align-items: center;
  gap: variables.$spacing-extra-small;
}

.starButton {
  flex: 0 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: variables.$gray;
  transition: color 0.15s ease;

  &:hover:not(.disabled) {
    color: variables.$blue;
  }

  &.starred {
    color: variables.$blue;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.editButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: variables.$gray;
  transition: color 0.15s ease;

  &:hover {
    color: variables.$blue;
  }
}

.saveSection {
  display: flex;
  gap: variables.$spacing-small;
  border-top: 1px solid variables.$gray;
  padding: variables.$spacing-medium;

  > span {
    flex: 1;
  }
}

.trigger {
  max-width: 14rem;

  > span {
    display: inline-block;
    max-width: calc(100%);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
}
